// Interests Actions
export const Interests_Makkah_Hotels = "Interests_Makkah_Hotels";
export const Interests_Madinah_Hotels = "Interests_Madinah_Hotels";
export const Interests_Airlines = "Interests_Airlines";
export const Interests_Progress = "Interests_Progress";
export const Interests_Current_Step = "Interests_Current_Step";
